import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{attrs:{"fluid":"","id":"dashboard"}},[_c(VImg,{staticClass:"mt-15",attrs:{"src":require(`/src/assets/large_logo.png`),"max-height":"300","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }